export default {

    data () {
        return {
            hideTitleImage: false,
            bgBackdrop: document.querySelector("#bg-backdrop")
        }
    },

    methods: {
        setTitleImageToBackground (question) {

            if(window.innerWidth > 767) {
                if(question.fullscreen_desktop) {
                    this.setBackdrop(question)
                } else {
                    this.removeBackdrop()
                }
            } else {
                if(question.fullscreen_mobile) {
                    this.setBackdrop(question)
                } else {
                    this.removeBackdrop()
                }
            }

        },

        setBackdrop (question) {
            this.bgBackdrop.style.backgroundImage = `url(${question.image})`
            this.bgBackdrop.classList.add('fade-bottom')
            this.hideTitleImage = true
            this.unsetFilterBackdrop()
        },

        removeBackdrop () {
            this.bgBackdrop.style.backgroundImage = ''
            this.bgBackdrop.classList.remove('fade-bottom')
            this.hideTitleImage = false
            this.setFilterBackdrop()
        },

        isSupportBasicFullscreen (question) {
            return question.type != "poll" && question.question_type == "basic" && question.image && question.image !== ''
        },

        setVideoToBackground (question) {

            if(window.innerWidth > 767) {
                if(question.fullscreen_desktop) {
                    this.setVideoBackDrop(question)
                } else {
                    this.removeVideoBackdrop()
                }
            } else {
                if(question.fullscreen_mobile) {
                    this.setVideoBackDrop(question)
                } else {
                    this.removeVideoBackdrop()
                }
            }

        },

        setVideoBackDrop (question) {

            this.bgBackdrop.classList.add('fade-bottom')

            const video = document.createElement('video')
            video.id = "videoBackground"
            video.classList.add('size-video-container')
            video.src = question.video
            video.loop = question.video_loop
            video.muted = true
            video.controls = false
            video.autoplay = true
            video.currentTime = question.video_time[0]
            video.setAttribute('playsinline', '');

            video.addEventListener('timeupdate', () => {
                if (parseInt(video.currentTime) + 1.1 > question.video_time[1]) {
                    video.currentTime = question.video_time[0]
                    if(question.video_loop) {
                        video.play()
                        return
                    }
                    video.pause()
                }
            })

            this.hideTitleImage = true

            this.bgBackdrop.appendChild(video)
            this.unsetFilterBackdrop()
        },

        removeVideoBackdrop () {
            if(document.querySelector('#videoBackground')) {
                document.querySelector('#videoBackground').remove()
            }
            this.bgBackdrop.classList.remove('fade-bottom')
            this.hideTitleImage = false
            this.setFilterBackdrop()
        },

        isSupportVideoFullscreen (question) {
            return question.question_type == "video" && question.video && question.video_provider != 'youtube'
        },

        setFilterBackdrop () {
            document.querySelector("#bg-backdrop").style['-webkit-filter'] = 'var(--bg-image-brightness) var(--bg-image-blur)'
            document.querySelector("#bg-backdrop").style['filter'] = 'var(--bg-image-brightness) var(--bg-image-blur)'
        },

        unsetFilterBackdrop () {
            document.querySelector("#bg-backdrop").style['-webkit-filter'] = 'unset'
            document.querySelector("#bg-backdrop").style['filter'] = 'unset'

        }

    }
}
